module.exports = __webpack_public_path__ + "static/img/product2.525e1a4.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/yiBrand/clean/product2.png
// module id = obsZ
// module chunks = 0